module.exports = __webpack_public_path__ + "img/DealerIcons-YouTube-On.119c9df.jpg";